import { defineStore } from 'pinia'
import type { ConfigApiData, ConfigInfoApi } from '~/server/types'
export interface CONFIG extends ConfigApiData {
  id?: number // 作为lang_id参数
}
export const useStore = defineStore('Config', () => {
  const config = ref<CONFIG>({} as CONFIG)
  async function fetchConfig() {
    const route = useRoute()
    const lang = route.params.lang || ''
    const res = await useFetch(`/api/cl-config?lang=${lang}`)
    if (!res.data.value) return
    const data = (res.data.value as ConfigInfoApi)?.data || null
    setConfig(data as ConfigApiData)
  }
  function setConfig(data: ConfigApiData) {
    config.value = data
    config.value.id = config.value.lang_list.find((item) => {
      return item.region === 'GLOBAL'
        ? item.lang === config.value.region_lang
        : `${item.region}_${item.lang}` === config.value.region_lang
    })?.id
  }

  function formatTransify(key: string) {
    return config.value.transify[key] || key
  }
  return {
    config,
    fetchConfig,
    formatTransify
  }
})
